module.exports = __webpack_public_path__ + "static/media/map-brussel.7d5ce877.png";